import { BuyAndGetYPctDiscountModel } from '@/b2c/shared/api/server-apis';
import { ComputedRef, inject, provide } from 'vue';

const provideBuyXAndGetYPercentScope: string = 'ProvideBuyXAndGetYPercentScope';
type BuyAndGetYPctDiscountType = ComputedRef<BuyAndGetYPctDiscountModel | undefined>;

export function provideBuyXAndGetYPercent(buyXAndGetYPercent: BuyAndGetYPctDiscountType): void {
    provide(provideBuyXAndGetYPercentScope, buyXAndGetYPercent);
}

export function injectBuyXAndGetYPercent() {
    const label = inject<BuyAndGetYPctDiscountType | undefined>(provideBuyXAndGetYPercentScope, undefined);
    return label;
}
